import { useState } from "react";
import { Button, CircularProgress, Tooltip } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const buttonIconFromState = (status, error) => {
  if (status === "idle") {
    return <SendIcon />;
  }

  if (status === "error") {
    return (
      <Tooltip title={error} arrow>
        <ErrorIcon />
      </Tooltip>
    );
  }

  if (status === "sending") {
    return <CircularProgress size={22} />;
  }

  if (status === "success") {
    return <CheckCircleIcon />;
  }

  return null;
};

const colorFromState = (status) => {
  if (status === "error") return "error";
  if (status === "success") return "success";
  return "inherit";
};

function SendRentalAgreementButton({ treatId, api, onSuccess }) {
  const [submitState, setSubmitState] = useState({
    status: "idle",
    error: "",
  });

  const onClick = async () => {
    setSubmitState((prev) => ({ status: "submitting", error: prev.error }));
    try {
      await api.sendRentalAgreement(treatId);
      setSubmitState({ status: "success", error: "" });
      onSuccess();
    } catch (err) {
      setSubmitState({ status: "error", error: err.message });
    }
  };

  const disableButton = submitState.status === "submitting";
  const buttonIcon = buttonIconFromState(submitState.status, submitState.error);
  const color = colorFromState(submitState.status);

  return (
    <Button
      size="large"
      variant="outlined"
      color={color}
      disabled={disableButton}
      onClick={onClick}
      endIcon={buttonIcon}
    >
      Send Rental Agreement
    </Button>
  );
}

export default SendRentalAgreementButton;
